(function () {
var root = document.getElementById('rq-root');
if (!root || root.dataset.rqInit) return;
root.dataset.rqInit = '1';
var CFG = window.RQ_CFG || {};
var $ = function (id) { return document.getElementById(id); };
var mainImg = $('rq-main');
var mainVid = $('rq-main-video');
var zoomBtn = $('rq-zoom');
var thumbs = root.querySelectorAll('.rq-thumb');
var form = $('rq-form');
var radios = root.querySelectorAll('input[name="rq-tier"]');
var rows = root.querySelectorAll('.rq-prow');
var picker = $('rq-picker');
var cutBtn = $('rq-cutbtn');
var cutSum = $('rq-cutsum');
var elPrice = $('rq-price');
var elTotal = $('rq-total');
var elWas = $('rq-was');
var elSave = $('rq-save');
var elAdd = $('rq-add');
var elAddT = $('rq-add-t');
var elMsg = $('rq-msg');
var elTally = $('rq-tally');
var elTallyN = $('rq-tally-n');
var elTallyH = $('rq-tally-hint');
var giftBox = $('rq-gift');
var giftNote = $('rq-giftnote');
var giftMsg = $('rq-giftmsg');
var giftCnt = $('rq-giftcount');
var sticky = $('rq-sticky');
var stickyT = $('rq-sticky-t');
var stickyP = $('rq-sticky-p');
var stickyS = $('rq-sticky-s');
var stickyB = $('rq-sticky-btn');
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/* One entry per thumbnail, in media order. `video` is the mp4 url for video
   media and '' for stills — that flag is what every branch below tests on. */
var shots = [];
for (var s = 0; s < thumbs.length; s++) {
var im = thumbs[s].querySelector('img');
if (!im) continue;
shots.push({
src: im.getAttribute('data-full') || im.src,
alt: thumbs[s].getAttribute('aria-label') || '',
video: thumbs[s].getAttribute('data-video') || ''
});
}
function anyStills() {
for (var i = 0; i < shots.length; i++) if (!shots[i].video) return true;
return false;
}
function onVideoSlide() {
return !!(shots.length && shots[cur] && shots[cur].video);
}
function tryPlay() {
if (!mainVid || reduce) return;
var p = mainVid.play();
/* A refused autoplay is a browser policy decision, not a fault: the poster
   stays up and the frame is still a usable first slide. */
if (p && p.catch) p.catch(function () {});
}
var cur = 0;
function show(i) {
if (!shots.length) return;
cur = (i + shots.length) % shots.length;
var shot = shots[cur];
if (shot.video && mainVid) {
if (mainVid.getAttribute('src') !== shot.video) mainVid.setAttribute('src', shot.video);
mainVid.style.display = '';
mainImg.style.display = 'none';
if (zoomBtn) zoomBtn.style.display = 'none';
tryPlay();
} else {
if (mainVid) { mainVid.pause(); mainVid.style.display = 'none'; }
mainImg.style.display = '';
mainImg.src = shot.src;
if (zoomBtn) zoomBtn.style.display = '';
}
for (var k = 0; k < thumbs.length; k++) thumbs[k].setAttribute('aria-current', k === cur ? 'true' : 'false');
}
for (var t = 0; t < thumbs.length; t++) {
(function (i) { thumbs[i].addEventListener('click', function () { show(i); }); })(t);
}
/* The loop is 11s of 1080p and Shopify exposes no lighter mp4 to Liquid (the
   reasoning is in snippets/rotary-media-src.liquid), so the saving actually
   available is not running it while nobody is looking. The markup carries the
   autoplay attribute so the first slide moves even if this file never loads;
   these two rules refine that once it has. */
if (mainVid) {
if (reduce) mainVid.pause();
if ('IntersectionObserver' in window) {
var vio = new IntersectionObserver(function (ents) {
for (var i = 0; i < ents.length; i++) {
if (ents[i].isIntersecting && onVideoSlide()) tryPlay();
else mainVid.pause();
}
}, { threshold: 0.15 });
vio.observe(mainVid);
}
document.addEventListener('visibilitychange', function () {
if (document.hidden) mainVid.pause();
else if (onVideoSlide()) tryPlay();
});
}
var lb = $('rq-lb');
var lbImg = $('rq-lb-img');
var lbCount = $('rq-lb-count');
var lastFocus = null;
function lbRender() {
lbImg.src = shots[cur].src;
lbImg.alt = shots[cur].alt;
lbCount.textContent = (cur + 1) + ' / ' + shots.length;
}
function lbOpen(i) {
if (!shots.length) return;
var n = (i + shots.length) % shots.length;
/* The lightbox is a still viewer. Video is played in place, so opening it on
   a video index would show that video's poster with no way to play it. */
if (shots[n].video) return;
lastFocus = document.activeElement;
cur = n;
lbRender();
lb.setAttribute('data-open', 'yes');
document.body.style.overflow = 'hidden';
$('rq-lb-close').focus();
}
function lbClose() {
lb.setAttribute('data-open', 'no');
document.body.style.overflow = '';
show(cur);
if (lastFocus) lastFocus.focus();
}
function lbStep(d) {
var n = shots.length, tries = 0;
do { cur = (cur + d + n) % n; tries++; } while (shots[cur].video && tries < n);
lbRender();
}
if (lb && shots.length && anyStills()) {
mainImg.addEventListener('click', function () { lbOpen(cur); });
if (zoomBtn) zoomBtn.addEventListener('click', function () { lbOpen(cur); });
$('rq-lb-close').addEventListener('click', lbClose);
$('rq-lb-prev').addEventListener('click', function () { lbStep(-1); });
$('rq-lb-next').addEventListener('click', function () { lbStep(1); });
lb.addEventListener('click', function (ev) { if (ev.target === lb) lbClose(); });
document.addEventListener('keydown', function (ev) {
if (lb.getAttribute('data-open') !== 'yes') return;
if (ev.key === 'Escape') lbClose();
if (ev.key === 'ArrowLeft') lbStep(-1);
if (ev.key === 'ArrowRight') lbStep(1);
});
var tx = 0;
lb.addEventListener('touchstart', function (ev) { tx = ev.changedTouches[0].clientX; }, { passive: true });
lb.addEventListener('touchend', function (ev) {
var dx = ev.changedTouches[0].clientX - tx;
if (Math.abs(dx) > 45) lbStep(dx < 0 ? 1 : -1);
}, { passive: true });
}
var items = root.querySelectorAll('.rq-r');
if ('IntersectionObserver' in window) {
var io = new IntersectionObserver(function (ents) {
for (var i = 0; i < ents.length; i++) {
if (ents[i].isIntersecting) { ents[i].target.classList.add('in'); io.unobserve(ents[i].target); }
}
}, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
for (var a = 0; a < items.length; a++) io.observe(items[a]);
} else {
for (var b = 0; b < items.length; b++) items[b].classList.add('in');
}
var links = root.querySelectorAll('[data-rq-scroll]');
for (var c = 0; c < links.length; c++) {
links[c].addEventListener('click', function (ev) {
var href = this.getAttribute('href');
if (!href) return;
var target = document.querySelector(href);
if (!target) return;
ev.preventDefault();
target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
});
}
function tier() {
for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
return radios[0];
}
function attr(el, k) { return el.getAttribute(k) || ''; }
function num(el, k) { return parseFloat(attr(el, k)) || 0; }
/* Two decimals throughout. The tier rows are rendered by Liquid's `money`
   filter and always carry them, so a bare "$140" next to "$140.00" read as
   two different numbers. */
function money(n) { return CFG.currency + (Math.round(n * 100) / 100).toFixed(2); }
var UNIT = CFG.setLabel || 'glass';
function unit(n) {
if (n === 1) return UNIT;
return /(?:s|x|z|ch|sh)$/i.test(UNIT) ? UNIT + 'es' : UNIT + 's';
}
function count(row) { return parseInt(row.querySelector('output').getAttribute('data-count'), 10) || 0; }
function setCount(row, n) {
var o = row.querySelector('output');
o.setAttribute('data-count', n);
o.textContent = n;
}
function picked() {
var s = 0;
for (var i = 0; i < rows.length; i++) s += count(rows[i]);
return s;
}
function selectionText() {
var parts = [];
for (var i = 0; i < rows.length; i++) {
var n = count(rows[i]);
if (n > 0) parts.push(n + ' ' + attr(rows[i], 'data-cut'));
}
return parts.join(', ');
}
function topUpAssorted() {
var qty = num(tier(), 'data-qty');
var have = picked();
var idx = 0;
while (have > qty) {
for (var j = rows.length - 1; j >= 0 && have > qty; j--) {
if (count(rows[j]) > 0) { setCount(rows[j], count(rows[j]) - 1); have--; }
}
}
while (have < qty && rows.length) {
var row = rows[idx % rows.length];
setCount(row, count(row) + 1);
have++; idx++;
}
}
function resetAssorted() {
for (var i = 0; i < rows.length; i++) setCount(rows[i], 0);
topUpAssorted();
}
function render() {
var tr = tier();
if (!tr) return;
var qty = num(tr, 'data-qty');
var total = num(tr, 'data-total');
var was = num(tr, 'data-was');
var each = num(tr, 'data-each');
var saved = was - total;
var p = picked();
/* The headline is the per-glass figure, not the set total: it is the number
   that stays small while the set grows, and the set is what the shopper is
   still deciding. The total is one line below and on the button, so nothing
   about what they pay is hidden — only reordered.

   The struck price is per-glass too. Comparing a per-glass price against a
   set total would be meaningless, and on this catalogue it lands well: every
   tier was $45 a glass before the set discount. */
var wasEach = qty ? was / qty : was;
elPrice.textContent = money(each);
if (elTotal) elTotal.textContent = money(total) + ' for ' + qty + ' ' + unit(qty);
if (saved > 0) {
elWas.textContent = money(wasEach); elWas.style.display = '';
elSave.textContent = 'save ' + money(saved); elSave.style.display = '';
stickyS.textContent = money(was); stickyS.style.display = '';
} else {
elWas.style.display = 'none';
elSave.style.display = 'none';
stickyS.style.display = 'none';
}
cutSum.textContent = selectionText() || 'Assorted mix';
elTallyN.textContent = p + ' of ' + qty;
elTally.setAttribute('data-full', p === qty ? 'yes' : 'no');
elTallyH.textContent = p === qty ? 'Your set is ready' : (p < qty ? 'We will fill the last ' + (qty - p) + ' with an even mix' : 'Remove ' + (p - qty));
for (var i = 0; i < rows.length; i++) {
rows[i].querySelector('[data-act="minus"]').disabled = count(rows[i]) === 0;
rows[i].querySelector('[data-act="plus"]').disabled = p >= qty;
}
elAddT.textContent = 'Add to cart · ' + money(total);
stickyT.textContent = qty + ' ' + unit(qty);
stickyP.textContent = money(total);
}
for (var d = 0; d < radios.length; d++) {
radios[d].addEventListener('change', function () { resetAssorted(); render(); });
}
if (cutBtn) cutBtn.addEventListener('click', function () {
var open = picker.getAttribute('data-open') === 'yes';
picker.setAttribute('data-open', open ? 'no' : 'yes');
this.textContent = open ? 'Change' : 'Done';
});
for (var e = 0; e < rows.length; e++) {
(function (row) {
var btns = row.querySelectorAll('.rq-step button');
for (var f = 0; f < btns.length; f++) {
btns[f].addEventListener('click', function () {
var act = this.getAttribute('data-act');
var qty = num(tier(), 'data-qty');
var now = count(row);
if (act === 'plus' && picked() < qty) setCount(row, now + 1);
if (act === 'minus' && now > 0) setCount(row, now - 1);
render();
});
}
})(rows[e]);
}
if (giftBox) {
giftBox.addEventListener('change', function () {
giftNote.setAttribute('data-open', this.checked ? 'yes' : 'no');
if (this.checked) giftMsg.focus();
});
giftMsg.addEventListener('input', function () { giftCnt.textContent = this.value.length; });
}
var buy = $('rq-buy');
if ('IntersectionObserver' in window && buy) {
var sio = new IntersectionObserver(function (ents) {
for (var i = 0; i < ents.length; i++) sticky.classList.toggle('on', !ents[i].isIntersecting);
}, { threshold: 0.05 });
sio.observe(buy);
}
function themeVariantId() {
var forms = document.querySelectorAll('form[action*="/cart/add"]');
for (var i = 0; i < forms.length; i++) {
if (forms[i].id === 'rq-form') continue;
var field = forms[i].querySelector('[name="id"]');
if (field && field.value) return field.value;
}
return '';
}
function say(text, state) {
elMsg.textContent = text || '';
elMsg.setAttribute('data-s', state || '');
}
function addToCart() {
var tr = tier();
if (!tr) return;
var qty = num(tr, 'data-qty');
if (picked() !== qty) { topUpAssorted(); render(); }
var id = attr(tr, 'data-variant');
var lineQty = 1;
if (!id) { id = themeVariantId(); lineQty = qty; }
if (!id) { say('We could not find the product variant.', 'err'); return; }
var props = {};
if (selectionText()) props[CFG.cutProperty] = selectionText();
if (giftBox && giftBox.checked) props[CFG.giftProperty] = (giftMsg.value || '').trim() || 'Yes — no message given';
elAdd.disabled = true; stickyB.disabled = true;
elAddT.textContent = 'Adding…';
say('', '');
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: [{ id: id, quantity: lineQty, properties: props }] })
})
.then(function (res) {
return res.json().then(function (data) {
if (!res.ok) throw new Error(data.description || data.message || 'We could not add that to your cart.');
return data;
});
})
.then(function () {
document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
if (CFG.redirectToCart) {
say('Added. Taking you to your cart…', 'ok');
window.location.href = '/cart';
} else {
elAdd.disabled = false; stickyB.disabled = false;
render();
say('Added to your cart.', 'ok');
}
})
.catch(function (err) {
elAdd.disabled = false; stickyB.disabled = false;
render();
say(err.message || 'Something went wrong. Try again.', 'err');
});
}
form.addEventListener('submit', function (ev) { ev.preventDefault(); addToCart(); });
stickyB.addEventListener('click', addToCart);
resetAssorted();
render();
})();
(function () {
var root = document.getElementById('rq-root-b');
if (!root || root.dataset.rqInit) return;
root.dataset.rqInit = '1';
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var items = root.querySelectorAll('.rq-r');
if ('IntersectionObserver' in window) {
var io = new IntersectionObserver(function (ents) {
for (var i = 0; i < ents.length; i++) {
if (ents[i].isIntersecting) { ents[i].target.classList.add('in'); io.unobserve(ents[i].target); }
}
}, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
for (var a = 0; a < items.length; a++) io.observe(items[a]);
} else {
for (var b = 0; b < items.length; b++) items[b].classList.add('in');
}
var links = root.querySelectorAll('[data-rq-scroll]');
for (var c = 0; c < links.length; c++) {
links[c].addEventListener('click', function (ev) {
var target = document.querySelector(this.getAttribute('href') || '');
if (!target) return;
ev.preventDefault();
target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
});
}
})();
